<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/portfolio', text: 'portfolio_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'portfolio_title' | translate}}</h1>
    </header>

    <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="activeTabId" (navChange)="onTabChange($event)">
        <li [ngbNavItem]="i + 1" *ngFor="let tab of tabs; let i = index">
            <a ngbNavLink>{{tab.title | translate}}</a>
            <ng-template ngbNavContent>
                <ng-container [ngSwitch]="tab.id">
                    <div class="mt-3">
                        <app-portfolio-programs *ngSwitchCase="'programs'"></app-portfolio-programs>
                        <app-portfolio-emrex *ngSwitchCase="'emrex'"></app-portfolio-emrex>
                    </div>
                </ng-container>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
